import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "tit-h2" }
const _hoisted_2 = { class: "btn-group" }

import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestView',
  setup(__props) {

const route = useRoute()

const current = ref(route.name)

watch(route, () => {
  current.value = route.name
})

const menuList = {
  Add: { title: '리퀘스트 추가', label: '리퀘스트 추가' },
  Board: { title: '수동 유료 고객 관리 보드', label: '대쉬보드', icon: 'fa-solid fa-table-columns' },
  Manage: { title: '리퀘스트 관리', label: '리퀘스트 관리' },
  PlanList: { title: '플랜 리스트', label: '플랜', icon: 'fa-solid fa-table-list' },
  PaymentList: { title: '결제 리스트', label: '결제', icon: 'fa-solid fa-table-list' },
}



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!(current.value === 'Add' || current.value === 'View' || current.value === 'Modify' || current.value === 'ViewStat'))
      ? (_openBlock(), _createElementBlock("header", {
          key: 0,
          class: _normalizeClass(["page-header", current.value.toLowerCase()])
        }, [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(menuList[current.value]?.title), 1),
          _createElementVNode("div", _hoisted_2, [
            (current.value === 'Board' || current.value === 'Manage')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {name: 'Add'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menuList['Add'].label), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ('Board' !== current.value && current.value === 'Manage')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: {name: 'Board'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: menuList['Board'].icon
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(menuList['Board'].label), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ('Manage' !== current.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: {name: 'Manage'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(menuList['Manage'].label), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ('PlanList' !== current.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  to: {name: 'PlanList'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: menuList['PlanList'].icon
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(menuList['PlanList'].label), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ('PaymentList' !== current.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 4,
                  to: {name: 'PaymentList'}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, {
                          icon: menuList['PaymentList'].icon
                        }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(menuList['PaymentList'].label), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})